
import PreHead from '~/components/ui/PreHead.vue'
import TrakkenCard from '~/components/ui/TrakkenCard.vue'
import BasicWaves from '~/components/BasicWaves.vue'
import CardSlider from '~/components/CardSlider.vue'

export default {
  props: {
    product: {
      type: Object,
      required: true
    },
    sellingPoints: {
      type: Array,
      required: true
    },
    hoverLight: {
      type: Boolean,
      required: false
    }
  },
  components: {
    PreHead,
    BasicWaves,
    CardSlider,
    TrakkenCard
  },
  mounted() {
    let parent = document.querySelector('.sticky').parentElement
    while (parent) {
      const hasOverflow = getComputedStyle(parent).overflow
      if (hasOverflow !== 'visible') {
        // console.log(hasOverflow, parent)
      }
      parent = parent.parentElement
    }
  },
  computed: {
    slides() {
      return this.sellingPoints[0].tile.map((tile) => {
        return {
          icon:
            tile &&
            tile !== undefined &&
            tile.icon !== undefined &&
            tile.icon[0] !== undefined &&
            tile.icon[0].icon !== undefined
              ? tile.icon[0].icon
              : null,
          subtitle:
            tile &&
            tile !== undefined &&
            tile.text !== undefined &&
            tile.text[0] !== undefined &&
            tile.text[0].textline !== undefined &&
            tile.text[0].textline[0] !== undefined &&
            tile.text[0].textline[0].text !== undefined
              ? tile.text[0].textline[0].text
              : null,
          blurb:
            tile &&
            tile !== undefined &&
            tile.text !== undefined &&
            tile.text[0] !== undefined &&
            tile.text[0].textblock !== undefined &&
            tile.text[0].textblock[0] !== undefined &&
            tile.text[0].textblock[0].text !== undefined
              ? tile.text[0].textblock[0].text
              : null,
          svgFillColor: this.svgFillColor,
          svgHoverFillColor: this.product.primaryColor,
          hoverColor: this.product.secondaryColor
        }
      })
    },
    cssVars() {
      return {
        '--bg-color': this.product.secondaryColor,
        '--svg-hover-color': this.product.primaryColor
      }
    },
    svgFillColor() {
      return this.product.primaryColor
    }
  }
}
